import gql from 'graphql-tag';
import {useQuery} from './query';

// Gets all sweeps for the given project

///// Query definition
export const ARTIFACT_TYPE_QUERY = gql`
  query ArtifactType(
    $projectName: String!
    $entityName: String!
    $artifactTypeName: String!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      artifactType(name: $artifactTypeName) {
        id
        name
        description
        artifactSequences(order: "-createdAt") {
          edges {
            node {
              id
              name
              description
              createdAt
              artifacts {
                totalCount
              }
            }
          }
        }
      }
    }
  }
`;

// // These types define the inputs and outputs of the above gql query

interface ProjectData {
  id: string;

  artifactType?: {
    id: string;
    name: string;
    description: string;
    artifactSequences: {
      edges: Array<{
        node: {
          id: string;
          name: string;
          description: string;
          createdAt: string;
          artifacts: {
            totalCount: number;
          };
        };
      }>;
    };
  };
}

// The query's output shape.
interface Data {
  project: ProjectData;
}

export function useArtifactTypeQuery(variables: {
  entityName: string;
  projectName: string;
  artifactTypeName: string;
}) {
  return useQuery<Data, typeof variables>(ARTIFACT_TYPE_QUERY, {
    variables,
    fetchPolicy: 'network-only',
    enablePolling: true,
  });
}
